import './Summary.scss';
import React from 'react';
import formatString from '../../../../utilities/format-string';
import _ from 'underscore';
import { setDateTime } from '../utils';

function setAmountTotal(montos, amount_name) {
  let sum = 0;
  _.each(montos, (item) => {
    if (item[amount_name] === '') {
      sum += 0;
    } else if (!_.isUndefined(item[amount_name])) {
      sum += parseInt(item[amount_name]);
    }
  });
  return sum;
}

function setGarantiaValor(requisition, type) {
  let res = '';
  if (type === 'LIQUIDA') {
    res = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    }).format(parseInt(requisition.garantia_valor));
  } else {
    res = requisition.garantia_valor;
  }
  return res;
}

function setPayday(number_day) {
  const days = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ];
  return days[number_day];
}

function setPayText(number) {
  let text = '';
  switch (number) {
    case 7:
      text = 'SEMANAL';
      break;
    case 14:
      text = 'CATORCENAL';
      break;
    case 28:
      text = 'BICATORCENAL';
      break;
    default:
      text = `${number} DÍAS REGULARES`;
      break;
  }
  return text;
}

const Summary = ({ requisition, fecha }) => {
  return (
    <div className="table-payment-control-summary">
      <table className="table table-borderless m-0">
        <tbody>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">SUCURSAL:</th>
            <td className="col-4 p-2">{requisition.Sucursal.nombre}</td>
            <th className="col-3 p-2 mr-0">MONTO DEL PRÉSTAMO:</th>
            <td className="col-2 p-2">
              {new Intl.NumberFormat('en', {
                style: 'currency',
                currency: 'USD',
              }).format(setAmountTotal(requisition.montos, 'monto_autorizado'))}
            </td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">PROMOTOR DE CRÉDITO:</th>
            <td className="col-4 p-2">
              {requisition.promotor.nombre}{' '}
              {requisition.promotor.apellido_paterno}{' '}
              {requisition.promotor.apellido_materno}
            </td>
            <th className="col-3 p-2 mr-0">GARANTÍA:</th>
            <td className="col-2 p-2">{requisition.garantia || '--'}</td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">FECHA DE ELABORACIÓN:</th>
            <td className="col-4 p-2">
              {formatString.setLegibleDate(
                new Date(setDateTime(fecha, 0, requisition)).toISOString()
              )}
            </td>
            <th className="col-3 p-2 mr-0">MONTO:</th>
            <td className="col-2 p-2">
              {setGarantiaValor(requisition, requisition.garantia) || '--'}
            </td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">
              NOMBRE DEL{' '}
              {requisition.Grupo.Socios.length === 1 ? 'CLIENTE' : 'GRUPO'}:
            </th>
            <td className="col-4 p-2">{requisition.Grupo.nombre}</td>
            <th className="col-3 p-2 mr-0">DÍA DE PAGO:</th>
            <td className="col-2 p-2 text-uppercase">
              {setPayday(requisition.dia_pago)}
            </td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">PLAZO:</th>
            <td className="col-4 p-2">
              {(requisition.prestamo_personalizado_periodicidad &&
                setPayText(requisition.prestamo_personalizado_periodicidad)) ||
                (requisition.cantidad_pagos_semanales && 'SEMANAL')}
            </td>
            <th className="col-3 p-2 mr-0">ID DE GRUPO:</th>
            <td className="col-2 p-2">
              {requisition.Grupo.id_en_sucursal}-
              {requisition.Grupo.Sucursal.sigla}
            </td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">PERIODICIDAD DE PAGO:</th>
            <td className="col-4 p-2">
              {(requisition.prestamo_personalizado_periodicidad &&
                `${requisition.prestamo_personalizado_periodicidad} DÍAS`) ||
                (requisition.cantidad_pagos_semanales && '7 DÍAS')}
            </td>
            <th className="col-3 p-2 mr-0">SOLICITUD:</th>
            <td className="col-2 p-2">{requisition.id_en_sucursal}</td>
          </tr>
          <tr className="d-flex">
            <th className="col-3 p-2 mr-0">NÚMERO DE PAGOS:</th>
            <td className="col-4 p-2">
              {requisition.prestamo_personalizado_cantidad_pagos
                ? requisition.prestamo_personalizado_cantidad_pagos
                : requisition.cantidad_pagos_semanales}
            </td>
            <th className="col-3 p-2 mr-0">CICLO:</th>
            <td className="col-2 p-2">{requisition.ciclo}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default Summary;
